/* SNS — The Art of Structure: day ghi danh sang Klaviyo truoc khi form post native.
   Luu y: KHONG gui 'subscriptions' trong profile.attributes — endpoint /client/subscriptions/
   tra 400 va tu set consent SUBSCRIBED roi. */
(function(){
  var roots = document.querySelectorAll('.aos-root[data-kl-key][data-kl-list]');
  for (var r = 0; r < roots.length; r++) {
    (function(root){
      var KL_KEY  = root.getAttribute('data-kl-key');
      var KL_LIST = root.getAttribute('data-kl-list');
      if (!KL_KEY || !KL_LIST) return;

      var forms = root.querySelectorAll('.rform form, .heroform form');
      if (!forms.length) return;

      for (var i = 0; i < forms.length; i++) bind(forms[i]);

      function bind(form){
      form.addEventListener('submit', function(e){
        if (form.getAttribute('data-aos-sent') === '1') return;
        e.preventDefault();

        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.style.opacity = '.6'; }

        var val = function(n){ var el = form.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ''; };
        var email = val('contact[email]');
        var full  = val('contact[Name]');
        var sp    = full.indexOf(' ');
        var optin = form.querySelector('#aos-optin');

        var sent = false;
        var go = function(){
          if (sent) return;
          sent = true;
          form.setAttribute('data-aos-sent', '1');
          form.submit();
        };

        if (!email) { go(); return; }

        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'The Art of Structure — Workshop Page',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    first_name: sp > 0 ? full.slice(0, sp) : full,
                    last_name:  sp > 0 ? full.slice(sp + 1) : '',
                    properties: {
                      'Workshop': val('contact[Workshop]'),
                      'Phone Raw': val('contact[Phone]'),
                      'Salon or Studio': val('contact[Salon or Studio]'),
                      'Team Size': val('contact[Team Size]'),
                      'Attending': val('contact[Attending]'),
                      'Day 2 Question': val('contact[body]'),
                      'Wants SNS Marketing': !!(optin && optin.checked),
                      'Registered Via': 'snsnails.com/pages/art-of-structure'
                    }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: KL_LIST } } }
          }
        };

        setTimeout(go, 3500);

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KL_KEY), {
          method: 'POST',
          headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify(payload)
        }).then(go, go);
      });
      }
    })(roots[r]);
  }
})();
